__turbopack_context__.v({
  "container": "FeaturedBox-module-scss-module__cVeUaa__container",
  "content": "FeaturedBox-module-scss-module__cVeUaa__content",
  "copy": "FeaturedBox-module-scss-module__cVeUaa__copy",
  "ctaContainer": "FeaturedBox-module-scss-module__cVeUaa__ctaContainer",
  "fullBleed": "FeaturedBox-module-scss-module__cVeUaa__fullBleed",
  "imageContainer": "FeaturedBox-module-scss-module__cVeUaa__imageContainer",
  "imageContainerMobile": "FeaturedBox-module-scss-module__cVeUaa__imageContainerMobile",
  "noOverlay": "FeaturedBox-module-scss-module__cVeUaa__noOverlay",
  "textContent": "FeaturedBox-module-scss-module__cVeUaa__textContent",
  "titleContainer": "FeaturedBox-module-scss-module__cVeUaa__titleContainer",
});
